import { render } from "./index.vue?vue&type=template&id=46c49de2"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/molecules/contact-summary-bar/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46c49de2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46c49de2', __exports__)) {
    api.reload('46c49de2', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=46c49de2", () => {
    api.rerender('46c49de2', render)
  })

}


export default __exports__